import type { FullSizeImage, ImageIndicators } from '@/domain/images';

type Indicators = Omit<ImageIndicators, 'maturity'>;

export const getImagesByIndicatorKey = (images: FullSizeImage[], cageId: number) => {
    return images.reduce(
        (acc, image) => {
            for (const [indicatorKey] of Object.entries(
                (image?.indicators as Indicators) || ({} as Indicators)
            )) {
                if (!acc[indicatorKey]) {
                    acc[indicatorKey] = [];
                }

                acc[indicatorKey].push(image);
            }
            return acc;
        },
        {} as Record<string, FullSizeImage[]>
    );
};
